import { ValidationItemUpdateMode } from "../ValidationItemUpdateMode";

export interface PdsrValidationItem {
  Id: number;
  ImportDate: Date;
  ContainerNetwork: string;
  SupplierGsdb: string;
  PlantGsdb: string;
  InboundDock: string;
  OutboundDock: string;
  ContainerType: string;
  FoldedFlag: string;
  Rc2Flag: boolean;
  InScope: boolean;
  FirstCollectionDate?: Date;
  LastModifiedUser: string;
  UpdateMode: ValidationItemUpdateMode;
  LastModifiedDateTime: Date;
  MaxStockQuantity: number | null;
}

export const rc2FlagAsString = new Map([
  [true, "YES"],
  [false, "NO"],
]);

export const inScopeAsString = new Map([
  [true, "IN SCOPE"],
  [false, "OUT OF SCOPE"],
]);
